import { postWindowMessage } from '@openeducation/oe-rn-services';
import { IFrameSizeEventType } from '@openeducation/oe-rn-shared-types';
import { useCallback } from 'react';
import type { LayoutChangeEvent } from 'react-native';

export function useLayoutEvents() {
  const postHeightLayoutEvent = useCallback((e: LayoutChangeEvent) => {
    postWindowMessage({
      type: IFrameSizeEventType.HEIGHT,
      height: e.nativeEvent.layout.height,
    });
  }, []);

  const postHeightMessage = useCallback((height: number) => {
    postWindowMessage({
      type: IFrameSizeEventType.HEIGHT,
      height,
    });
  }, []);

  return {
    postHeightLayoutEvent,
    postHeightMessage,
  };
}
